import type {
  GetAppIntegrationUsersParams,
  GetSoftwareLicenseSubGroupsParams,
  GetSoftwareUserGroupsParams,
} from './type';

export const softwareKey = {
  all: (id: string) => ['software', id] as const,
  rule: (id: string) => [...softwareKey.all(id), 'rules'] as const,
  setting: (id: string) => [...softwareKey.all(id), 'settings'] as const,
  users: (id: string) => [...softwareKey.all(id), 'users'] as const,
  usersSearch: (id: string, search: GetAppIntegrationUsersParams) =>
    [...softwareKey.users(id), 'search', { search }] as const,
  usersRoles: (id: string) => [...softwareKey.users(id), 'roles'] as const,
  usersStatuses: (id: string) =>
    [...softwareKey.users(id), 'statuses'] as const,
  licenseSubGroupsSearch: (
    id: string,
    search: GetSoftwareLicenseSubGroupsParams,
  ) => [...softwareKey.all(id), 'license-subgroups', { search }] as const,
  userGroupsSearch: (id: string, search: GetSoftwareUserGroupsParams) =>
    [...softwareKey.all(id), 'user-groups', { search }] as const,

  contract: (id: string) => [...softwareKey.all(id), 'contract'] as const,
} as const;
